import * as React from "react";
import { Dropdown } from "ui/Scripts/source/components/framework/dropdown";
import { ICompanyMenuItem } from "ui/Scripts/source/models/company/companyMenuItem";
import { Translations } from "ui/Scripts/source/models/translations";
import { IUserListItem } from "../../../models/user/userListItem";
import { UserListItems } from "../../../models/user/userListItems";
import { FormSectionTitle } from "../../framework/Form/FormSectionTitle";
import { ISelectUserDialogState, SelectUserDialogList } from "../SelectUserDialog/SelectUserDialog";
import { CompanyItem } from "source/components/company/Company/CompanyItem";
import { Grid } from "@mui/material";
import { VerticalContainer } from "ui/Scripts/source/components/framework/VerticalContainer";

export interface ISelectUserListProps {
    classes?: string;
    companies: ICompanyMenuItem[];
    ignoreUserIds?: string[];
    ignoreUserCodes?: string[];
    ignoreRecordUserConnected?: boolean;
    doNotIgnoreRecordUserConnectedUserCode?: string;
    showUserGroupsCompanyId: string;
    multiSelect?: boolean;
    selectedIds?: string[];
    title?: string;
    onSelect: (users: IUserListItem[], companyId :string) => void;
    onGetUserSelectListItems?: (companyId: string, pageSize: number, page: number, filter: string,
        ignoreUserIds: string[], ignoreUserCodes: string[], activityState: number, ignoreRecordUserConnected: boolean, ignoreQrCodeUsers: boolean, requireQrCodeUsers: boolean,
        doNotIgnoreRecordUserConnectedUserCode: string, sortColumn: string, sortOrderIsAsc: boolean) => Promise<UserListItems>
}

export interface ISelectUserListState extends ISelectUserDialogState {
    company: ICompanyMenuItem;
}

export class SelectUserList extends React.Component<ISelectUserListProps, ISelectUserListState> {
    constructor(props: ISelectUserListProps) {
        super(props);
        this.state = {
            intialized: false,
            company: props.companies.length ? props.companies[0] : null,
            selectedId: !props.multiSelect && props.selectedIds && props.selectedIds.length > 0 ? props.selectedIds[0] : null,
            checkedIds: props.multiSelect && props.selectedIds ? props.selectedIds : [],
            selectedItems: []
        };
    }

    handleSetInitialized = (intialized: boolean) => {
        this.setState({
            intialized
        });
    };

    handleSetSelectedIds = (selectedId: string, checkedIds: string[], selectedItems: IUserListItem[]) => {
        const state = this.state;
        this.setState({
            selectedId,
            checkedIds,
            selectedItems
        });
        if (!state.company) return;
        this.props.onSelect(selectedItems, state.company.id);
    };

    handleCompanyChange = (companyId: string) => {
        const props = this.props;
        const company = props.companies.find(i => i.id === companyId);
        if (!company) return;
        this.setState({
            company
        });
    };

    render() {
        const props = this.props;
        const state = this.state;
        if (!state.company) return null;
        return (
            <VerticalContainer
                before={<>
                    {props.companies.length > 1 &&
                        <div className="form-group">
                            <FormSectionTitle>{Translations.SelectCompany}</FormSectionTitle>
                            <Dropdown
                                autoHeight={true}
                                selectedTitle={<Grid sx={{ display: "flex", alignItems: "center" }} ><CompanyItem company={state.company} /></Grid>}
                                selectMode={true}
                                tooltip={Translations.SelectCompany}
                                actions={props.companies.map((company) => {
                                    return {
                                        title: <CompanyItem company={company} />,
                                        textTitle: company.name,
                                        selected: company.id === state.company.id,
                                        onClick: () => this.handleCompanyChange(company.id)
                                    };
                                })}
                            />
                        </div>
                    }
                    {!!props.title &&
                        <FormSectionTitle>{props.title}</FormSectionTitle>
                    }
                </>}
                main={<>
                    <SelectUserDialogList
                        companyId={state.company.id}
                        ignoreUserIds={props.ignoreUserIds}
                        ignoreUserCodes={props.ignoreUserCodes}
                        ignoreRecordUserConnected={props.ignoreRecordUserConnected}
                        doNotIgnoreRecordUserConnectedUserCode={props.doNotIgnoreRecordUserConnectedUserCode}
                        hideUserGroups={state.company.id !== props.showUserGroupsCompanyId}
                        multiSelect={props.multiSelect}
                        intialized={state.intialized}
                        selectedId={state.selectedId}
                        checkedIds={state.checkedIds}
                        onSetIntialized={this.handleSetInitialized}
                        onSetSelected={this.handleSetSelectedIds}
                        onGetUserSelectListItems={props.onGetUserSelectListItems}
                    />
                </>}
            />
        );
    }
}